import { Constantes } from "../constants/constantsGlobal"
import setupInterceptor from "./setupInterceptor"

export const chatbotDownloadFileDatacenter = async (
  fileUrl: string,
  fileName: string,
  user: any,
  setUser: (user: any) => void
  ): Promise<void> => {
    try {
      const response = await setupInterceptor(
    Constantes.URI_ChatBotDatacenterDownloadFileDatacenter,
    user,
    setUser,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: fileUrl } ),
    }
  )

  const blob = await response.blob()

  const downloadUrl = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = downloadUrl
  link.download = fileName  
  link.click()

  window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.error("Error descargando archivo:", error)
      throw error
    }
}
